<template>
  <!-- <div class="d-flex flex-wrap">
    <div class="card min-width-440 min-height-434 mr-3">
      <ChartColumnChannel
        :title-chart="'_ReportChannel.Sales by Channel Type'"
        :chart-data="overviewData.total_sales"
      />
    </div>
    <div class="card min-width-440 min-height-434 mr-3">
      <ChartColumnChannel
        :title-chart="'_ReportChannel.Orders by Channel Type'"
        :chart-data="overviewData.number_of_orders"
      />
    </div>
    <div class="card min-width-440 min-height-434 mr-3">
      <ChartDonutChannel
        :title-chart="'_ReportChannel.Orders by Channel Group'"
        :chart-data="overviewData.channel_group"
      />
    </div>
  </div> -->
  <div class="row mb-3">
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartColumnChannel
          :title-chart="'_ReportChannel.Sales by Channel Type'"
          :chart-data="overviewData.total_sales"
        />
      </div>
    </div>
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartColumnChannel
          :title-chart="'_ReportChannel.Orders by Channel Type'"
          :chart-data="overviewData.number_of_orders"
        />
      </div>
    </div>
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartDonutChannel
          :title-chart="'_ReportChannel.Orders by Channel Group'"
          :chart-data="overviewData.channel_group"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChartColumnChannel from './ChartColumnChannel.vue';
import ChartDonutChannel from './ChartDonutChannel.vue';

export default {
  name: "OverviewChartSalesByChannel",
  components: {
    ChartColumnChannel,
    ChartDonutChannel,
  },
  props: {
    overviewData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  created() {
    // console.log(this.overviewData)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/chart/salesbychannel/OverviewChart.vue